import React from 'react';
import { Navigate } from 'react-router-dom';
import { readUserInfo } from '../../services/pageAccess';
import { isSaRole } from '../../services/managementService';

const SaAdminRoute = ({ children }) => {
  if (!isSaRole(readUserInfo().Role)) {
    return <Navigate to="/home" replace />;
  }
  return children;
};

export default SaAdminRoute;
